import { InfoTooltip, VStack, Text, Image } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PreviewModeTooltip: React.FC = () => {
  const { t } = useTranslation();

  return (
    <InfoTooltip
      label={
        <VStack spacing="4">
          <Text>
            {t('FLOWS_COMPANY-SCAN_VIEW-ONLY-HEADER_PREVIEW-DESCRIPTION')}
          </Text>
          <Image
            borderRadius="md"
            src="https://files.wegroup.be/product/ask-later/5e66dc4545b981b8c16b2f9669b26824.gif"
          />
        </VStack>
      }
      iconName="GeneralStatusInfo"
      color="primary.500"
      boxSize={6}
      flexGrow={1}
    />
  );
};

export default PreviewModeTooltip;
